<template>
  <div id="app_content" class="reserved">

    <div class="header">
      <div class="header-container">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h2>{{ trans.get('b2b.personal-area.personal') }}</h2>
            </div>
            <div class="col-md-12 schede">
              <ul>
                <li
                  :class="section === 'anagrafica' ? 'active-tab' : ''"
                  @click="section = 'anagrafica'"
                >
                  {{ trans.get('b2b.personal-area.profile') }}
                  <span
                    v-if="section === 'anagrafica'"
                    class="active-bar"
                  ></span>
                </li>
                <li
                  :class="section === 'ordini' ? 'active-tab' : ''"
                  @click="section = 'ordini'"
                >
                  {{ trans.get('b2b.personal-area.orders') }}
                  <span v-if="section === 'ordini'" class="active-bar"></span>
                </li>
                <li
                  :class="section === 'documenti' ? 'active-tab' : ''"
                  @click="section = 'documenti'"
                >
                  {{ trans.get('b2b.personal-area.documents') }}
                  <span
                    v-if="section === 'documenti'"
                    class="active-bar"
                  ></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="section === 'anagrafica'" id="anagrafica" class="anagrafica">
      <div class="container body" v-if="isLoaded">
        <div class="row">
          <div class="col-md-12">
            <h1>{{ indirizzi[0].rag_soc }}</h1>
          </div>
        </div>
        <div class="row anagrafica">
          <div class="col-lg-4 col-md-6">
            <h4>{{ trans.get('b2b.personal-area.address') }}</h4>
            <p>{{ indirizzi[0].indirizzo }}</p>
            <p>
              {{ indirizzi[0].cap }} {{ indirizzi[0].localita }} -
              {{ indirizzi[0].provincia }}
            </p>
          </div>
          <div class="col-lg-4 col-md-6">
            <h4>{{ trans.get('b2b.personal-area.phone') }}</h4>
            <p>{{ indirizzi[0].tel_1 }}</p>
            <p>{{ indirizzi[0].tel_2 }}</p>
          </div>
          <div class="col-lg-4 col-sm-6 mt-5">
            <p>{{ trans.get('b2b.personal-area.email') }}</p>
            <p>{{ indirizzi[0].email }}</p>
          </div>
        </div>
        <div class="row anagrafica">
          <div class="col-md-6">
            <h4>{{ trans.get('b2b.personal-area.company-name') }}</h4>
            <p>{{ indirizzi[0].rag_soc }}</p>
          </div>
          <div class="col-md-6">
            <h4>{{ trans.get('b2b.personal-area.vat') }}</h4>
            <p>{{ anagrafica.partita_iva }}</p>
            <p></p>
          </div>
        </div>
        <div class="row anagrafica">
          <div class="col-md-4">
            <p>{{ trans.get('b2b.personal-area.cod-fiscale') }}</p>
            <p>{{ anagrafica.codice_fiscale }}</p>
          </div>
          <div class="col-md-4">
            <p>{{ trans.get('b2b.personal-area.pec-address') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="section === 'anagrafica'" class="indirizzi">
      <div class="container">
        <div class="row spedizione">
          <div class="col-md-12">
            <h3>{{ trans.get('b2b.personal-area.shipping-addr') }}</h3>
          </div>
          <div class="col-md-12 addresses" v-for="(i, k) in indirizzi">
            <h4>{{ trans.get('b2b.personal-area.address') }} {{ k + 1 }}</h4>
            <p>{{ i.rag_soc }}</p>
            <p>{{ i.indirizzo }}</p>
            <p>{{ i.cap }} {{ i.localita }} {{ i.provincia }}</p>
            <hr />
          </div>
        </div>
        <!--        <div class="row fatturazione">
          <div class="col-md-12">
            <h3>Indirizzo di fatturazione</h3>
            <h4>Indirizzo 1</h4>
            <p>The office </p>
            <p>Via roma, 22</p>
            <p>31254 Padova PD</p>
          </div>
        </div>-->
        <div class="row preferenze">
          <div class="col-md-12">
            <h3>{{ trans.get('b2b.personal-area.preferences') }}</h3>
            <div class="newsletter pt-30">
              <span class="text-uppercase col-md-7 col-12"
                >{{ trans.get('b2b.personal-area.newsletter') }}</span
              >
              <div class="col-md-4 col-12">
                <input id="yes" name="ns1" type="radio" :value="1" v-model="newsletter" @change="setNewsletter" />
                <label for="yes">{{ trans.get('b2b.personal-area.yes') }}</label>
                <input id="no" name="ns1" type="radio" :value="0" v-model="newsletter" @change="setNewsletter"/>
                <label for="no">{{ trans.get('b2b.personal-area.no') }}</label>
              </div>
            </div>
            <div class="newsletter">
              <span class="text-uppercase col-md-7 col-12">
                {{ trans.get('b2b.personal-area.commercial') }}
              </span>
              <div class="col-md-4 col-12">
                <input id="2yes" name="ns2" type="radio" :value="1" v-model="marketing" @change="setNewsletter"/>
                <label for="2yes">{{ trans.get('b2b.personal-area.yes') }}</label>
                <input id="2no" name="ns2" type="radio" :value="0" v-model="marketing" @change="setNewsletter"/>
                <label for="2no">{{ trans.get('b2b.personal-area.no') }}</label>
              </div>
              <div class="col-md-4">
                <b-message v-model="isActive" class="messaggio-newsletter" type="is-success">
                  {{ trans.get('b2b.personal-area.success') }}
                </b-message>
              </div>
            </div>
            <div class="language">
              <span class="text-uppercase col-md-7 col-12"> {{trans.get('b2b.personal-area.language')}}</span>
              <div class="col-md-4 col-12">
                <b-field >
                  <b-select :placeholder="$trans('b2b.personal-area.select-language')" @input="setLang">
                    <option :key="i"  :value="lang" v-for="(lang, i) in languages">{{ lang.toUpperCase() }}</option>

                  </b-select>
                </b-field>
              </div>
            </div>
          </div>
        </div>
<!--        <div class="row preferenze">-->
<!--          <div class="col-md-4 col-6">-->
<!--            <h4>Nome</h4>-->
<!--            <p class="text-grey">Mario</p>-->
<!--          </div>-->
<!--          <div class="col-md-4 col-6">-->
<!--            <h4>Cognome</h4>-->
<!--            <p class="text-grey">Rossi</p>-->
<!--          </div>-->
<!--          <div class="col-md-4 col-6">-->
<!--            <h4>Email</h4>-->
<!--            <p class="text-grey">email@email.it</p>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <ordini v-if="section==='ordini'"/>
    <documenti v-if="section==='documenti'"/>

  </div>
</template>

<script>
import ordini from "./ordini";
import documenti from "./documenti"


export default {
  name: "index",
  components: {
    ordini,
    documenti
  },
  data(){
    return {
      section: (sessionStorage.getItem('section'))? sessionStorage.getItem('section') : 'anagrafica',
      anagrafica: null,
      indirizzi: null,
      isLoaded: false,
      newsletter: null,
      marketing: null,
      isActive: false,
      languages: null,

    }
  },
  watch: {
    section: function () {
      sessionStorage.setItem('section', this.section)
    },
  },
  mounted() {
    this.fetchAnagrafica()
    this.getNewsletter()
    this.getLanguages()
  },
  methods: {
    setLang: function (lang) {
      //console.log(lang)
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/userLocale',
        params: {
          action: 'set',
          lang: lang,
        }
      }).then(res => {
        console.log(res.data)
      })
    },
    getLanguages: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/userLocale',
        params: {
          action: 'get'
        }
      }).then(res => {
         this.languages = res.data
      })
    },
    setNewsletter: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/newsletter',
        params: {
          type: 'set',
          marketing: this.marketing,
          newsletter: this.newsletter,
        }
      })
      .then(res => {
        this.isActive = true
        setTimeout(()=>{
          this.isActive = false
        },5000)
      })
          .catch(err =>{
            console.log(err.response)
          })
    },
    getNewsletter: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/newsletter',
        params: {
          type: 'get'
        }
      })
      .then(res =>{
        this.newsletter = (res.data.newsletter === 0) ? 0 : 1
        this.marketing = (res.data.marketing === 0) ? 0 : 1
      })
      .catch(err =>{
        console.log(err.response)
      })
    },
    fetchAnagrafica: function () {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/anagrafica'
      })
      .then(result => {
        this.anagrafica = result.data.user
        this.indirizzi = result.data.addresses
        this.isLoaded = true
      })
      .catch(error => {
        console.log(error)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.reserved {

  .text-grey {
    color: #8c8d88;
  }

  .header {
    .header-container {
      padding-bottom: 23px;
    }
    display: flex;
    margin: 0;
    color: #ffffff;
    width: 100vw;
    background-color: var(--dark-gray);

    h2 {
      max-width: 1200px;
      //margin-top: 76px;
      margin-bottom: 45px;
      font-size: 34px;
    }

    .schede {
      ul {
        display: flex;
        li {
          cursor: pointer;
          color: #6d6d6d;
          position: relative;
          margin-right: 50px;
          &.active-tab {
            color: #fff;
          }
        }
        li .active-bar {
          display: inline-block;
          width: 100%;
          height: 3px;
          position: absolute;
          left: 0;
          top: 100%;
          background-color: var(--greenb2b);
        }
      }
    }
  }

  .anagrafica {
    background-color: #f5f5f5;

    .body {
      font-size: 16px;

      h1 {
        font-size: 35px;
        padding: 54px 0;
      }

      .anagrafica {
        padding-bottom: 54px;

        h4 {
          text-transform: uppercase;
          margin: 10px 0;
        }
      }
    }
  }

  .indirizzi {
    h3 {
      font-size: 24px;
    }
    .spedizione,
    .fatturazione,
    .preferenze {
      padding: 27px 0;
      h4 {
        color: #0c0c0c;
      }

      h3 {
        font-size: 24px;
        margin-bottom: 20px;
      }

      h4 {
        text-transform: uppercase;
        margin: 10px 0;
      }
      .newsletter {
        position: relative;
        &.pt-30 {
          padding-top: 30px;
          padding-bottom: 30px;
        }
        display: flex;
        flex-direction: column;
        align-items: center;
        input:first-child {
          margin-left: auto;
        }
        label {
          margin-left: 5px;
          margin-right: 10px;
        }
        .messaggio-newsletter {
          position: absolute;
          top: -80px;
        }
      }
      .language {
        display: flex;
        padding: 30px 0;
        span {
          display: inline-block;
          line-height: 40px;
        }
      }
    }
    .spedizione{
      display: flex;

      .addresses {
        display: flex;
        flex-direction: column;
        hr {
          background-color: #979797;
        }
        p {
          text-transform: lowercase;
          &:first-letter {
            text-transform: uppercase;
          }
        }
      }
    }
  }
}
@media (min-width: 576px) {
  .reserved {
    .header {
    }
    .anagrafica {
      .body {
        h1 {
          font-size: 48px;
        }
      }
      .indirizzi {
        .spedizione,
        .fatturazione,
        .preferenze {
          .newsletter {
            display: flex;
            flex-direction: row;
            width: 70%;
            .col-md-6 {
              padding-left: 0;
            }
          }
        }
      }
    }
  }
  .reserved .indirizzi .spedizione .newsletter[data-v-7e68a967], .reserved .indirizzi .fatturazione .newsletter[data-v-7e68a967], .reserved .indirizzi .preferenze .newsletter[data-v-7e68a967]{
    flex-direction: row;
  }
}

@media (min-width: 1200px) {
  .reserved {
    .container {
      width: 80%;
      padding: 0;
      .col-md-12 {
        padding: 0;
      }
    }

    .header {
      height: 200px;

      .header-container {
        margin: 0 auto;
        padding: 64px 0 23px 0;

        width: 80%;
        & > .container {
          width: 100%;
        }
      }
      .schede {
        ul {
          width: 60%;
        }
      }
    }
    #anagrafica {
      margin-bottom: 20px;
    }
    .indirizzi {
      padding-top: 63px;
    }
  }
}
</style>
